export default "__VITE_ASSET__3exDGzd3__"